import script from "./ImagemComp.vue?vue&type=script&setup=true&lang=js"
export * from "./ImagemComp.vue?vue&type=script&setup=true&lang=js"

import "./ImagemComp.vue?vue&type=style&index=0&id=95eaf75a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-95eaf75a"]])

export default __exports__